import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    exercicesList : [],
    selectedExercice:{},
}
const exercicesSlice = createSlice({
    name:'exercices',
    initialState,
    reducers:{
        setExercicesList:(state,{payload})=>{
            state.exercicesList = payload
        },
        setSelectedExercice:(state,{payload})=>{
            state.selectedExercice = payload
        },
    }
})

export const { setExercicesList,setSelectedExercice} = exercicesSlice.actions
export default exercicesSlice.reducer